// Einheitliche Kostenberechnung für die ganze App.
// Claude Sonnet 4.6: $3 / 1 Mio. Input-Tokens, $15 / 1 Mio. Output-Tokens.
// Annahme ~40% Input / 60% Output, da Input/Output pro Anzeige nicht getrennt
// gespeichert werden → Schätzwert. USD→EUR ~0,92.
const PRICE_IN_PER_M = 3;
const PRICE_OUT_PER_M = 15;

export function formatCost(tokens) {
  const t = parseInt(tokens, 10) || 0;
  if (t === 0) return "—";
  const costUsd = (t * 0.4 * PRICE_IN_PER_M + t * 0.6 * PRICE_OUT_PER_M) / 1_000_000;
  const costEur = costUsd * 0.92;
  if (costEur < 0.01) return "< 0,01 €";
  return costEur.toFixed(2).replace(".", ",") + " €";
}

// Formatiert einen bereits berechneten EUR-Betrag (gespeicherte, exakte Kosten pro Anzeige).
export function formatEur(eur) {
  const v = Number(eur) || 0;
  if (v === 0) return "—";
  if (v < 0.01) return "< 0,01 €";
  return v.toFixed(2).replace(".", ",") + " €";
}
